import { config } from '@/configs/env';
import { apiFetch, AuthError } from '@/lib/api-service';
import { RedirectToLoginError } from '@/lib/auth';
import {
  AddToCartResponse,
  CartError,
  CartItemRequest,
} from '@/types/cart.types';

const CART_API_BASE = config.CART_API_BASE;

export async function addToCartService(
  item: CartItemRequest,
  storeId: number
): Promise<AddToCartResponse> {
  try {
    const url = `${CART_API_BASE}/carts/item`;
    const params = new URLSearchParams({ storeId: storeId.toString() });

    return await apiFetch<AddToCartResponse>(`${url}?${params}`, {
      method: 'POST',
      body: item,
      requireAuth: true,
    });
  } catch (error: unknown) {
    if (error instanceof AuthError || error instanceof RedirectToLoginError) {
      throw error;
    }

    throw {
      code: 'ADD_TO_CART_FAILED',
      message:
        typeof error === 'object' && error !== null && 'message' in error
          ? String(error.message)
          : item.quantity === 1
            ? 'Failed to add item to cart'
            : item.quantity === 0
              ? 'Failed to remove item from cart'
              : 'Failed to update item quantity in cart',
      details: error instanceof Error ? error.message : error,
    } as CartError;
  }
}

export async function getCartService(
  storeId: number,
  redirectLogin: boolean = false
): Promise<AddToCartResponse> {
  try {
    const params = new URLSearchParams({ storeId: String(storeId) });
    const url = `${CART_API_BASE}/carts`;

    return await apiFetch<AddToCartResponse>(`${url}?${params}`, {
      method: 'GET',
      requireAuth: true,
      redirectLogin,
    });
  } catch (error: unknown) {
    if (error instanceof AuthError || error instanceof RedirectToLoginError) {
      throw error;
    }

    throw {
      code: 'GET_CART_FAILED',
      message:
        typeof error === 'object' && error !== null && 'message' in error
          ? String(error.message)
          : 'Failed to fetch cart',
      details: error instanceof Error ? error.message : error,
    } as CartError;
  }
}
